export default {
	// NavSidebarHOC.vue
	NavSidebarHOC_teamsGroupTitle: "My Teams",
	NavSidebarHOC_oneOnOnesGroupTitle: "My 1:1s",
	NavSidebarHOC_meetingsGroupTitle: "Meetings",
	NavSidebarHOC_goalsGroupTitle: "Goals",
	NavSidebarHOC_commitmentsGroupTitle: "My Action Items",
	NavSidebarHOC_profileGroupTitle: "My Profile",
	NavSidebarHOC_coachingGroupTitle: "Free Coaching Session",
	NavSidebarHOC_demoGroupTitle: "Schedule a Demo",
	NavSidebarHOC_subscribeGroupTitle: "Trial mode. Buy now.",
	NavSidebarHOC_settingsGroupTitle: "Settings & Billing",
	NavSidebarHOC_signOutGroupTitle: "Sign out",

	// ShowmoreItems.vue
	ShowmoreItems_showMoreLabel: "show more",
	ShowmoreItems_showFewerLabel: "show fewer",
};



// WEBPACK FOOTER //
// ./src/lang/en/sidebar.js